import { combineReducers } from "redux";
import dashboardReducer from "./DashboardRedux/DashboardReducer";
import TimeCardsReducer from "./TimeCardsRedux/TimeCardsReducer";
import { DV_Reducer } from "./TimeCardsRedux/TimeCardsReducer";
import {ReConsolidationClients_Reducer} from "./TimeCardsRedux/TimeCardsReducer";
import { ReConsolidationClientHeaderData_Reducer } from "./TimeCardsRedux/TimeCardsReducer";
import { userManagementReducer } from "./UserManagementRedux/UserManagementReducer";

const rootReducer = combineReducers({
    dashboardreducer : dashboardReducer,
    timecardsReducer : TimeCardsReducer,
    dvReducer:DV_Reducer,
    rcClientsReducer : ReConsolidationClients_Reducer,
    rcClientHeaderReducer : ReConsolidationClientHeaderData_Reducer,
    userManagementReducer : userManagementReducer
})

export default rootReducer;